import assign from 'lodash/assign';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    rows: [],
    propertyDetails: {},
});

const boostAdReport = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ANALYTICS_BOOST_AD_GET_SUCCESS:
            return assign({}, state, payload);

        case DispatchConstants.ANALYTICS_BOOST_AD_GET_FAIL:
            return state;

        default:
            return state;
    }
};

export default boostAdReport;
